import React from 'react';
import './style.css';

const Checkbox = ({
  id,
  label = '',
  defaultChecked,
  disabled,
  onClick = () => {},
  onChange = () => {},
  checked,
  classNameLabel = '',
  className = '',
}) => {
  return (
    <div
      className={`${disabled ? 'opacity-40' : 'cursor-pointer'}  ${className}`}
    >
      <label
        className={`container-checkbox !font-medium !text-sm cursor-pointer text-[#344054] flex items-center pl-6 ${classNameLabel}`}
        htmlFor={id}
      >
        {label}
        <input
          type="checkbox"
          id={id}
          name={id}
          value={checked}
          checked={checked}
          defaultChecked={defaultChecked}
          disabled={disabled}
          onClick={(e) => onClick(e)}
          onChange={(e) => onChange(e)}
          className={`${disabled ? '' : 'cursor-pointer'}`}
        />
        {disabled ? (
          <span className={`disabled-checkmark`}></span>
        ) : (
          <span className={`checkmark`}></span>
        )}
      </label>
    </div>
  );
};

export { Checkbox };
